<div class="login__page login-page-slider">
    <!-- Denefits 360 hero slide -->
    <div class="denefits-hero">
        <div class="denefits-hero__media">
            <video #heroVideo class="denefits-hero__video" [src]="hero.videoUrl" autoplay muted loop playsinline
                webkit-playsinline preload="auto" disablePictureInPicture
                controlslist="nodownload noplaybackrate" aria-label="Denefits 360 overview"></video>
        </div>

        <div class="denefits-hero__copy">
            <p class="denefits-hero__eyebrow notranslate">{{ hero.eyebrow }}</p>
            <h2 class="denefits-hero__title">
                <span class="denefits-hero__title--accent">{{ hero.titleTop }}</span>
                <span class="denefits-hero__title--dark">{{ hero.titleBottom }}</span>
            </h2>
        </div>
    </div>

    <!-- this ng template was previously carouselA -->
    <ng-template>
        <carousel [noWrap]="noWrapSlides" class="h-100 user_carousel" [showIndicators]="showIndicator">
            <slide style="transition: none;">
                <div class="main-wrapper">
                    <div class="wrapper-head"
                        style="background: #F0FCFF;width: 100%;height: 39.818px;border-radius: 16px 16px 0 0;">
                    </div>
    
    
                    <div class="wrapper-body" style="text-align: center;padding: 36px 24px;">
                        <p style="color: #030225;text-align: center;font-size: 14px;font-weight: 300;margin: 0 0 16px;">
                            Please enter the Payment Amount
                        </p>
    
                        <h4 class="notranslate"
                            style="color: #49485F;font-size: 20.537px;font-weight: 800;border-radius: 12.835px;background: #F8FBFF;padding: 12px;max-width: 220px;margin: 0 auto 14px;">
                            $48.89
                        </h4>
    
                        <button
                            style="border-radius: 5.99px;background:  #1581E5;padding: 8px 20px;border: none;color: rgba(255, 255, 255,0.6);text-align: center;font-size: 10px;font-weight: 700;">
                            Make Payment
                        </button>
                    </div>
                    <div class="wrapper-footer"
                        style="display: flex;justify-content: space-between;align-items: center;padding: 16px 0;border-radius: 13.264px;background: #F8FBFF;margin: 0 24px;">
                        <div style=" margin: 0 8px;">
                            <p
                                style=" margin: 0 0 12px; height: 8px; width: 80px; border-radius: 13.426px; background: #83CAE0;">
                            </p>
                            <p style="color: #49485F;font-size: 14px;font-weight: 900;margin: 0 0 0;" class="notranslate">
                                $48.89
                            </p>
                        </div>
    
                        <div style="margin: 0 8px;">
                            <p
                                style="margin: 0 0 12px;height: 8px;width: 60px;border-radius: 13.426px;background: rgb(131 202 224 / 40%);">
                            </p>
                            <p style="color: rgb(73 72 95 / 60%);font-size: 14px;font-weight: 900;margin: 0 0 0;" class="notranslate">
                                $48.89
                            </p>
                        </div>
                        <div style="margin: 0 8px;">
                            <p
                                style="margin: 0 0 12px;height: 8px;width: 55px;border-radius: 13.426px;background: rgb(131 202 224 / 40%);">
                            </p>
                            <p style="color: rgb(73 72 95 / 60%);font-size: 14px;font-weight: 900;margin: 0 0 0;" class="notranslate">
                                $48.89
                            </p>
                        </div>
                        <div style="margin: 0 8px;">
                            <button
                                style="color: rgb(120 120 120 / 60%);text-align: center;font-size: 10px;font-weight: 700;padding: 8px;border-radius: 6.19px;border: 0.884px solid  #C3C8CD;background: #fff;">
                                Send Invoice
                            </button>
                        </div>
                    </div>
    
                    <div class="topcard"
                        style="filter: drop-shadow(0px 21.861055374145508px 21.861055374145508px rgba(0, 0, 0, 0.06));background: #16293A;width: 240px;padding: 24px 20px;border-radius: 14px;position: absolute;top: -58px;left: 26px;">
                        <h4
                            style="color: rgba(255, 255, 255,0.6);font-size: 13.119px;font-weight: 700;margin: 0 0 16px;text-align: center;">
                            Accepted Payment Methods
                        </h4>
    
                        <div style="display: flex;justify-content: space-around;align-items: center;">
                            <div style="display: flex;justify-content: space-around;align-items: center;">
                                <!-- <img src="assets\img\png\debit.png" alt=""> -->
                                <h3 style="color: #FFF;font-size: 18px;font-weight: 600;margin: 0 10px;">Card</h3>
                            </div>
                            <div style="display: flex;justify-content: space-around;align-items: center;">
                                <!-- <img src="assets\img\png\bankhome.png" alt=""> -->
                                <h3 style="color: #FFF;font-size: 18px;font-weight: 600;margin: 0 10px;">ACH</h3>
                            </div>
                        </div>
                    </div>
                    <img src="assets\img\svg\green-tick.svg" alt="" style="position: absolute;right: 0;bottom: -80px;">
                </div>
                <div style="
                    width: 412.288px;
                    margin: 0px auto;" class="main-wrapper-content">
                    <p
                        style="font-family: Lato; font-size: 32px;  font-weight: 700; line-height: 40px; letter-spacing: 0em;">
                        Smart checkout, tailored to <br>every customer
                    </p>
                </div>
            </slide>
            <slide style="transition: none;">
                <div class="main-wrapper second-mainwrapper">
                    <div class="wrapper-head"
                        style="background: #F0FCFF;width: 100%;height: 39.818px;border-radius: 16px 16px 0 0;"></div>
    
    
                    <div class="wrapper-body" style="text-align: center;padding: 36px 20px;">
                        <p style="color: #030225;font-size: 18px;font-weight: 600;">
                            How would you like to split the <span class="notranslate">$30.25</span> transaction fee?
                        </p>
                        <div class="w-100">
                            <mat-slider class="example-margin" [disabled]="disabled" [max]="max" [min]="min" [step]="step">
                              <input aria-labelledby="example-name-label" [(ngModel)]="transationSlider"
                                [ngModelOptions]="{ standalone: true }" matSliderThumb>
                            </mat-slider>
                            <div class="second-mainwrapper-card">
                                <span class="content notranslate">$20.25 </span>
                                <p><span class="notranslate">$530.25</span> <span class="subcontent">
                                        Total Amount
                                    </span></p> <span class="content notranslate">$10.00</span>
                            </div>
                            <div class="second-mainwrapper-button">
                                <span>Next</span>
                            </div>
                        </div>
                        <div class="wrapper-footer"
                            style="display: flex;justify-content: space-between;align-items: center;padding: 16px 0;border-radius: 13.264px;background: #F8FBFF;margin: 0 24px; margin-top: 1.2rem;">
                            <div style=" margin: 0 8px;">
                                <p
                                    style=" margin: 0 0 12px; height: 8px; width: 80px; border-radius: 13.426px; background: #83CAE0;">
                                </p>
                            </div>
    
                            <div style="margin: 0 8px;">
                                <p
                                    style="margin: 0 0 12px;height: 8px;width: 60px;border-radius: 13.426px;background: rgb(131 202 224 / 40%);">
                                </p>
                            </div>
                            <div style="margin: 0 8px;">
                                <p
                                    style="margin: 0 0 12px;height: 8px;width: 55px;border-radius: 13.426px;background: rgb(131 202 224 / 40%);">
                                </p>
                            </div>
                        </div>
    
    
                    </div>
    
    
                    <div class="topcard"
                        style="filter: drop-shadow(0px 21.861055374145508px 21.861055374145508px rgba(0, 0, 0, 0.06));background: #3791E5;width: 190px;padding: 20px;border-radius: 14px;position: absolute;top: -75px;right: 25px;">
                        <h4 style="color: rgb(255 255 255 / 60%);font-size: 11px;font-weight: 700;margin: 0 0 8px;">
                            Invoice Amount
                        </h4>
                        <h2 style="color: #FFF;font-size: 24px;font-weight: 700;margin: 0 0 10px;" class="notranslate">
                            $600.00
                        </h2>
                    </div>
                    <img src="assets\img\svg\green-tick.svg" alt="" style="position: absolute;right: 0;bottom: -80px;">
    
                </div>
                <div style="
                    width: 412.288px;
                    margin: 0px auto;" class="main-wrapper-content">
                    <p style="font-family: Lato;
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 40px;
                    letter-spacing: 0em;
                    color: #030225;
                    ">Smart reminders keep everything on track. <br>No chasing.
                    </p>
                </div>
            </slide>
            <slide style="transition: none;">
                <div class="main-wrapper">
                    <div class="wrapper-head"
                        style="background: #F0FCFF;width: 100%;height: 39.818px;border-radius: 16px 16px 0 0;"></div>
    
    
                    <div class="wrapper-body" style="text-align: center;padding: 36px 20px;">
                        <div style="display: flex;justify-content: space-between;margin: 0;padding: 0 0px; ">
                            <div>
                                <div
                                    style="height: 11px;width: 195px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 0 14px 0 0; ">
                                </div>
                                <div
                                    style="height: 11px;width: 120px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 0 0; ">
                                </div>
                            </div>
                            <div
                                style="height: 11px;width: 69px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 0; ">
                            </div>
    
                        </div>
    
    
    
                        <div style="display: flex;margin: 16px 0 0;width: 100%;overflow-x: hidden;">
                            <div
                                style="border-radius: 12.802px;background: #F8FBFF;padding: 16px 8px;margin: 0 4px 0 0;text-align: left;">
    
                                <h4 style="color: #030225;font-size: 14px;font-weight: 300;margin: 0 0 6px;">12 months</h4>
                                <h2 style="color: #49485F;font-size: 20px;font-weight: 800;margin: 0 0 16px;" class="notranslate">
                                    $48.89
                                </h2>
    
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0;">
                                </div>
    
                                <div
                                    style="height: 11px;width: 120px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0;">
                                </div>
    
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0; ">
                                </div>
    
                                <button
                                    style="border-radius: 5.974px;background:  #1581E5;color: rgb(255 255 255 / 60%);font-size: 9px;font-weight: 700;border: none;padding: 6px 16px;margin: 12px 0 0;width: 100%;">
                                    Select Plan
                                </button>
                            </div>
                            <div
                                style="border-radius: 12.802px;background: #3791E5;padding: 16px 8px;margin: 0 4px;text-align: left;">
    
                                <h4 style="color: #FFFFFF;font-size: 14px;font-weight: 300;margin: 0 0 6px;">18 months</h4>
                                <h2 style="color: #FFFFFF;font-size: 20px;font-weight: 800;margin: 0 0 16px;" class="notranslate">
                                    $35.32
                                </h2>
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(0 0 0 / 30%);margin: 5px 14px 8px 0; ">
                                </div>
                                <div
                                    style="height: 11px;width: 120px;border-radius: 12.647px;background: rgb(0 0 0 / 30%);margin: 5px 14px 8px 0;">
                                </div>
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(0 0 0 / 30%);margin: 5px 14px 8px 0; ">
                                </div>
                                <button
                                    style="border-radius: 5.974px;background: #FFFFFF;color: #49485F;font-size: 9px;font-weight: 700;border: none;padding: 6px 16px;margin: 12px 0 0;width: 100%;">
                                    Select Plan
                                </button>
                            </div>
                            <div
                                style="border-radius: 12.802px;background: #F8FBFF;padding: 16px 8px;margin: 0 0 0 4px;text-align: left;">
    
                                <h4 style="color: #030225;font-size: 14px;font-weight: 300;margin: 0 0 6px;">20 months</h4>
                                <h2 style="color: #49485F;font-size: 20px;font-weight: 800;margin: 0 0 16px;" class="notranslate">
                                    $32.87
                                </h2>
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0; ">
                                </div>
    
                                <div
                                    style="height: 11px;width: 120px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0;">
                                </div>
    
                                <div
                                    style="height: 11px;width: 60px;border-radius: 12.647px;background: rgb(131 202 224 / 60%);margin: 5px 14px 8px 0;">
                                </div>
                                <button
                                    style="border-radius: 5.974px;background:  #1581E5;color: rgb(255 255 255 / 60%);font-size: 9px;font-weight: 700;border: none;padding: 6px 16px;margin: 12px 0 0;width: 100%;">
                                    Select Plan
                                </button>
                            </div>
                        </div>
    
                    </div>
    
    
                    <div class="topcard"
                        style="filter: drop-shadow(0px 21.861055374145508px 21.861055374145508px rgba(0, 0, 0, 0.06));background: #3791E5;width: 190px;padding: 20px;border-radius: 14px;position: absolute;top: -75px;right: 25px;">
                        <h4 style="color: rgb(255 255 255 / 60%);font-size: 11px;font-weight: 700;margin: 0 0 8px;">
                            Down Payment?
                        </h4>
                        <h2 style="color: #FFF;font-size: 24px;font-weight: 700;margin: 0 0 10px;" class="notranslate">
                            $200.00
                        </h2>
    
                        <p style="color: #030225;font-size: 10px;font-weight: 600;">
                            Plan Payment Amount
                        </p>
                        <div style="display: flex;align-items: center;margin: 14px 0 0;">
    
                            <div
                                style="height: 8px;width: 40px;border-radius: 12.647px;background: #FFF;margin: 0 14px 0 0;">
                            </div>
                            <div
                                style="height: 8px;width: 20px;border-radius: 12.647px;background: #FFF;margin: 0 14px 0 0;">
                            </div>
                        </div>
    
                    </div>
                    <img src="assets\img\svg\green-tick.svg" alt="" style="position: absolute;right: 0;bottom: -80px;">
    
                </div>
                <div style="
                    width: 412.288px;
                    margin: 0px auto;" class="main-wrapper-content">
                    <p style="font-family: Lato;
                    font-size: 32px;
                    font-weight: 700;
                    line-height: 40px;
                    letter-spacing: 0em;
                    ">Launch faster with minimal <br>setup
                    </p>
                </div>
            </slide>
        </carousel>
    </ng-template>
</div>